import { AbstractValueObject } from './abstractValueObject';

/**
 * 単一項目のValueObject.
 */
export abstract class PrimitiveValueObject<T> extends AbstractValueObject<T> {
  /** 値 */
  get value(): T {
    return this.val;
  }
}
